const { getLanguage } = require('core/i18n').i18n;

let localLang = getLanguage();

const image1 = require(`assets/images/tutorials/${ localLang }/general7/slide1.svg`);
const image2 = require(`assets/images/tutorials/${ localLang }/general7/slide2.svg`);
const image3 = require(`assets/images/tutorials/${ localLang }/general7/slide3.svg`);
const image4 = require(`assets/images/tutorials/${ localLang }/general7/slide4.svg`);
const image5 = require(`assets/images/tutorials/${ localLang }/general7/slide5.svg`);

const images = [image1, image2, image3, image4, image5];

module.exports = images;
